import axios from "axios";

import APP_CONFIG from "../app/configuration/AppConfig";
import { ModuleRuntimeStatus, SiteAppModule, siteAppModuleToIotHubModuleName } from "./AppConfigModels";

export async function ensureSiteModuleTypeExists(
  siteId: string,
  siteApp: SiteAppModule,
  deviceId: string
) {
  const url = `${APP_CONFIG.serviceUrls.siteGatewayUrlPrefix}/site/${siteId}/${deviceId}/module/${siteApp}`;
  await axios.post(url);
}

export async function generateTagsHarvesterConfig(siteId: string) {
  const url = `${APP_CONFIG.serviceUrls.siteAppsConfigUrlPrefix}/GenerateTagsHarvesterConfig/${siteId}`;
  await axios.post(url);
}

export async function generateSiteControlModuleConfig(
  siteId: string,
  deviceId: string,
  siteApp: SiteAppModule,
  appVersion: string
) {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/siteAppConfigs/${siteId}/${siteApp}/generate`;
  const params = {
    AppVersion: appVersion,
    DeviceId: deviceId,
  };
  return (await axios.post<string[]>(url, params)).data;
}

export async function addOrUpdateTagInIotDevice(deviceId: string, tagName: string, tagValue: string) {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/iotHubDeployments/devices/${deviceId}/tags/${tagName}?tagValue=${encodeURI(tagValue)}`;
  await axios.post(url);
}

export async function getModuleStatusOnDevice(siteId: string, deviceId: string, siteApp: SiteAppModule) {
  const moduleName = siteAppModuleToIotHubModuleName[siteApp];
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/iotHubDeployments/sites/${siteId}/${deviceId}/${moduleName}/runtimeStatus`;
  const httpResponse = await axios.get<ModuleRuntimeStatus>(url);
  return httpResponse.data;
}

export async function getTagValueOfDevice(deviceId: string, tagName: string) {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/iotHubDeployments/devices/${deviceId}/tags/${tagName}`;
  const httpResponse = await axios.get<string | null>(url);
  return httpResponse.data;
}

export async function getDeploymentVersions(tagName: string, signal?: AbortSignal) {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/iotHubDeployments/versions/${tagName}`;
  return (await axios.get<string[]>(url, { signal })).data;
}
